import { render, staticRenderFns } from "./productSourcing.vue?vue&type=template&id=2f30df6e"
import script from "./productSourcing.vue?vue&type=script&lang=js"
export * from "./productSourcing.vue?vue&type=script&lang=js"
import style0 from "./productSourcing.vue?vue&type=style&index=0&id=2f30df6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports